import { render, staticRenderFns } from "./FinishResult.vue?vue&type=template&id=ce65f254&scoped=true"
import script from "./FinishResult.vue?vue&type=script&lang=js"
export * from "./FinishResult.vue?vue&type=script&lang=js"
import style0 from "./FinishResult.vue?vue&type=style&index=0&id=ce65f254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce65f254",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QAvatar,QCard,QCardSection,QCardActions,QBtn});qInstall(component, 'directives', {ClosePopup});
